import { adminCall, adminGet } from '../../api/adminCall';

export const resetPortalSlugCooldown = async (companyId) => {
  return adminCall(
    `/api/admin/companies/${encodeURIComponent(companyId)}/portal-slug-cooldown/reset`
  );
};

export const purgeCompany = async ({ companyId, confirmCompanyName }) => {
  return adminCall(`/api/admin/companies/${encodeURIComponent(companyId)}/purge`, {
    confirmCompanyName,
  });
};

export const searchCompaniesForPurge = async ({ query = '', page = 0, pageSize = 10 } = {}) => {
  const qs = new URLSearchParams();
  if (query) qs.set('query', query);
  qs.set('page', String(page));
  qs.set('pageSize', String(pageSize));
  return adminGet(`/api/admin/companies/search?${qs.toString()}`);
};
